<template>
  <div
    :id="`component-layout-${id}`"
    class="component-layout"
    :class=" class_name_for_all || '' + ' ' + main_color || ''">
    <div
      class="container main_container pb-6"
      :class="(!fluid_main_container ? ' thin ' : '  pl-8 ')
        + (main_color || '') + ' ' + (content_class || '') + (wihout_footer ? ' full-height' : '' ) "
      :fluid="fluid_main_container"
      pa-0
      :style="contentStyle">
      <div
        class="pt-4 breadcrumbs">
        <slot name="breadcrumbs"/>
      </div>
      <div
        class="main-content my-0 "
        :class="main_color">
        <slot name="main_content"/>
      </div>
    </div>
    <ComponentsTemplatesFooter v-if="!wihout_footer">
      <slot name="footer"/>
    </ComponentsTemplatesFooter>
  </div>
</template>

<script>
import ComponentsTemplatesFooter from 'pages/templates/ComponentsTemplatesFooter.vue'

export default {
  name: 'componentLayout',
  props: {
    id: {
      type: String,
      default: 'component-layout'
    },
    main_color: {
      type: String,
      default: ''
    },
    class_name_for_all: {
      type: String,
      default: ''
    },
    fluid_main_container: Boolean,
    content_class: {
      type: String,
      default: ''
    },
    wihout_footer: Boolean,
    contentStyle: {
      type: String,
      default: ''
    },
  },
  components: {
    ComponentsTemplatesFooter
  }
}
</script>
<style lang="scss" scoped>
.component-layout {
  position: relative;
}
.container {
  background-color: var(--v-main__green-base) !important;
  padding-top: 0 !important;
  padding: 12px;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: 1264px) {
    .container {
      max-width: 1185px;
    }
  }
  @media (min-width: 960px) {
    .container {
      max-width: 900px;
    }
  }
  .breadcrumbs {
    position: sticky;
    top: 0;
    z-index: 1;
    background: var(--v-main__green-base);
  }
}
.main_container {
  height: calc(100vh - 72px);
  overflow: auto;
  position: relative ;
  padding-bottom: 25px !important;
  &.full-height {
    height: 100vh;
  }
  &, div {
    width: 100%;
    max-width: 100%;
  }
  &.thin div {
    width: 804px;
    margin: 0 auto;
  }
  .bredcrumbs {
    max-height: 55px;
    width: 100%;
  }
}
.sticky {
  z-index: 6;
  position: sticky;
  top: 0
}
</style>
